import PageHero from "@/components/PageHero";
import IslamicValues from "@/components/IslamicValues";
import { IMAGES, SCHOOL } from "@/lib/site";
import { motion } from "framer-motion";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <PageHero eyebrow="ABOUT US" title="Our Story" subtitle="A legacy of trust, education and care — built over 25+ years in Chikkamagaluru." />

      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-14 items-center">
          <motion.img initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
            src={IMAGES.building} alt="School building" className="rounded-3xl shadow-xl w-full h-[520px] object-cover" />
          <div>
            <span className="inline-block bg-gold/15 text-gold-dark px-4 py-1 rounded-full text-xs font-bold tracking-[0.25em]">EST. {SCHOOL.established}</span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-bold mt-5 text-royal">Nurturing minds, shaping futures.</h2>
            <div className="gold-divider" />
            <p className="mt-5 text-gray-700 leading-relaxed">
              Established under the Royal Education Society (R.), Royal English Medium High School has been a cornerstone of quality
              English-medium education in Chikkamagaluru since 1999. We believe in a balanced approach — combining strong
              academics with sports, arts, and value-based learning.
            </p>
            <p className="mt-4 text-gray-700 leading-relaxed">
              Our state-of-the-art campus, dedicated faculty, and inclusive culture make us the trusted choice for parents
              across Chikkamagaluru and surrounding regions.
            </p>
          </div>
        </div>
      </section>

      <IslamicValues />
    </div>
  );
}
